// The condensed layout: full-width pages with a left nav rail instead of header tabs. New look only, opted into
// from Customize appearance.
import { getThemeVariant, THEME_VARIANTS } from './theme-variant';

export const CONDENSED_LAYOUT_STORAGE_KEY = 'branch-staff-condensed-layout';

export const getCondensedLayoutPreference = () => {
  try {
    return window.localStorage.getItem(CONDENSED_LAYOUT_STORAGE_KEY) === 'on';
  } catch {
    return false;
  }
};

// Returns false when the browser refuses the write (disabled storage, quota).
export const saveCondensedLayoutPreference = (enabled) => {
  try {
    window.localStorage.setItem(CONDENSED_LAYOUT_STORAGE_KEY, enabled ? 'on' : 'off');
    return true;
  } catch {
    return false;
  }
};

let condensedLayout;

// Read once and fixed for the page load, like the theme variant: Apply & refresh saves and reloads.
export const isCondensedLayout = () => {
  condensedLayout ??= getThemeVariant() === THEME_VARIANTS.RESKIN && getCondensedLayoutPreference();
  return condensedLayout;
};

// For style rules only the condensed layout applies: spread into a JSS rule. The condensed theme sets the flag.
export const condensedStyles = (theme, styles) => (theme.condensedLayout ? styles : {});
